const defaultGenerator = (componentName: string) => componentName

const createClassNameGenerator = () => {
  let generate = defaultGenerator
  return {
    configure(generator: typeof generate) {
      generate = generator
    },
    generate(componentName: string) {
      return generate(componentName)
    },
    reset() {
      generate = defaultGenerator
    }
  }
}

const ClassNameGenerator = createClassNameGenerator()

const globalStateClassesMapping: Record<string, string> = {
  active: 'csg-tui-active',
  checked: 'csg-tui-checked',
  completed: 'csg-tui-completed',
  disabled: 'csg-tui-disabled',
  error: 'csg-tui-error',
  expanded: 'csg-tui-expanded',
  focused: 'csg-tui-focused',
  focusVisible: 'csg-tui-focusVisible',
  required: 'csg-tui-required',
  selected: 'csg-tui-selected'
}

export function generateUtilityClass(
  componentName: string,
  slot: string
): string {
  const globalStateClass = globalStateClassesMapping[slot]
  return (
    globalStateClass || `${ClassNameGenerator.generate(componentName)}-${slot}`
  )
}

export function generateUtilityClasses<T extends string>(
  componentName: string,
  slots: T[]
): Record<T, string> {
  const result: Record<string, string> = {}

  slots.forEach((slot: string) => {
    result[slot] = generateUtilityClass(componentName, slot)
  })

  return result
}

export function composeClasses<ClassKey extends string>(
  slots: Record<ClassKey, ReadonlyArray<string | false | undefined | null>>,
  getUtilityClass: (slot: string) => string,
  classes: Record<string, string> | undefined
): Record<ClassKey, string> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const output: Record<ClassKey, string> = {} as any

  Object.keys(slots).forEach(
    // `Objet.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot: ClassKey) => {
      output[slot] = slots[slot]
        .reduce((acc, key) => {
          if (key) {
            if (classes && classes[key]) {
              acc.push(classes[key])
            }
            acc.push(getUtilityClass(key))
          }
          return acc
        }, [] as string[])
        .join(' ')
    }
  )

  return output
}

export default ClassNameGenerator
